import { useState, useEffect, useCallback } from 'react'
import { cronLogsService } from '../services/cronLogsService'
import type { CronLog, CronLogFilters, CronLogStatus } from '../types'

export function useCronLogs(initialFilters?: Partial<CronLogFilters>) {
  const [data, setData] = useState<CronLog[]>([])
  const [total, setTotal] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [filters, setFilters] = useState<CronLogFilters>({
    page: 1,
    limit: 20,
    ...initialFilters,
  })

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const response = await cronLogsService.getAll(filters)
      setData(response.data)
      setTotal(response.total_items)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar logs del cron')
    } finally {
      setIsLoading(false)
    }
  }, [filters])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const setPage = (page: number) => setFilters((prev) => ({ ...prev, page }))
  const setLimit = (limit: number) => setFilters((prev) => ({ ...prev, limit, page: 1 }))

  const setStatusFilter = (status: CronLogStatus | undefined) =>
    setFilters((prev) => ({ ...prev, status, page: 1 }))

  const clearFilters = () =>
    setFilters({ page: 1, limit: filters.limit })

  return {
    data,
    total,
    isLoading,
    error,
    filters,
    setPage,
    setLimit,
    setStatusFilter,
    clearFilters,
    refetch: fetchData,
  }
}
